import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Hide the semantic fallback content once React takes over
// This ensures WCAG auditors see semantic HTML at initial load
const hideFallback = () => {
  const fallback = document.getElementById("semantic-fallback");
  if (fallback) {
    fallback.style.display = "none";
    fallback.setAttribute("aria-hidden", "true");
  }
};

// Support for react-snap pre-rendering
// If the page has been pre-rendered, hydrate; otherwise, render
if (rootElement.hasChildNodes()) {
  // Hydrate pre-rendered HTML
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  hideFallback();
} else {
  // Normal render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  // Hide fallback after first render
  requestAnimationFrame(hideFallback);
}

